<app-product-carousel></app-product-carousel>
<div class="text-justify">
    <app-aboutus></app-aboutus>
    <app-features></app-features>
    <app-testimonials></app-testimonials>
    <app-clients></app-clients>
</div>

